// ===== PELOMEO THEME JS =====

// Gallery
var galleryIndex = 0;
function switchGallery(index) {
  var imgs = document.querySelectorAll('.gallery-img');
  var total = imgs.length;
  if (!total) return;
  index = ((index % total) + total) % total;
  galleryIndex = index;
  imgs.forEach(function (img, i) { img.classList.toggle('active', i === index); });
  var thumbs = document.querySelectorAll('.pdp-thumbs .thumb');
  thumbs.forEach(function (t, i) { t.classList.toggle('active', i === index); });
  var strip = document.querySelector('.pdp-thumbs');
  var active = thumbs[index];
  if (strip && active) {
    strip.scrollTo({ left: Math.max(0, active.offsetLeft - (strip.clientWidth - active.clientWidth) / 2), behavior: 'smooth' });
  }
  var counter = document.getElementById('gallery-counter');
  if (counter) counter.textContent = (index + 1) + ' / ' + total;
}
function galleryStep(dir) { switchGallery(galleryIndex + dir); }

(function () {
  var box = document.getElementById('main-img');
  if (!box) return;
  var sx = 0, sy = 0;
  box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  box.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - sx;
    var dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) galleryStep(dx < 0 ? 1 : -1);
  }, { passive: true });
})();

// Offer selection
function selectOffer(card) {
  document.querySelectorAll('.offer').forEach(function (c) {
    c.classList.remove('selected');
    c.setAttribute('aria-checked', 'false');
  });
  card.classList.add('selected');
  card.setAttribute('aria-checked', 'true');
  var input = document.getElementById('variant-id');
  if (input) input.value = card.dataset.variant;
  var btn = document.getElementById('cta-btn');
  if (btn) btn.textContent = btn.dataset.label + ' — ' + card.dataset.price;
  var sp = document.getElementById('sticky-price');
  if (sp) sp.textContent = card.dataset.price + (card.dataset.save ? ' · ' + card.dataset.save : '');
}

// Tabs
document.addEventListener('click', function (e) {
  var tab = e.target.closest('.tab-btn');
  if (!tab) return;
  var root = tab.closest('.tabs');
  root.querySelectorAll('.tab-btn').forEach(function (b) { b.setAttribute('aria-selected', b === tab ? 'true' : 'false'); });
  root.querySelectorAll('.tab-panel').forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
});

// FAQ
function toggleFaq(btn) {
  var item = btn.parentElement;
  var isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(function (it) {
    it.classList.remove('open');
    it.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
    it.querySelector('.faq-a').style.maxHeight = '0';
  });
  if (!isOpen) {
    item.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    var a = item.querySelector('.faq-a');
    a.style.maxHeight = a.scrollHeight + 'px';
  }
}

// Scroll to offers
function goToOffers() {
  var el = document.getElementById('offers') || document.getElementById('product');
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

// Sticky add-to-cart: visible once the main button has scrolled out of view
(function () {
  var bar = document.getElementById('sticky-atc');
  var cta = document.getElementById('cta-btn');
  if (!bar || !cta || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    bar.classList.toggle('visible', !e.isIntersecting && e.boundingClientRect.top < 0);
  }).observe(cta);
})();

/* advertorial sticky bar */
(function(){
  var bar = document.querySelector('.adv-sticky');
  if (!bar) return;
  var shown = false;
  window.addEventListener('scroll', function(){
    if (window.scrollY > 600 && !shown) { bar.classList.add('visible'); shown = true; }
    else if (window.scrollY <= 600 && shown) { bar.classList.remove('visible'); shown = false; }
  });
})();
